import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=2116aa66&scoped=true&"
import script from "./Drawer.vue?vue&type=script&lang=ts&"
export * from "./Drawer.vue?vue&type=script&lang=ts&"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=2116aa66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2116aa66",
  null
  
)

component.options.__file = "Drawer.vue"
export default component.exports